import { GenericSelect } from '@chain-zen/ui'
import React from 'react'

interface BaseStatusMenuProps<T extends string> {
  canEdit: boolean
  currentStatus: T
  disabledStatuses?: T[]
  handleUpdateStatus: (params: { status: T }) => void
  labelComponent: (status: T) => React.ReactNode
  statuses: T[]
}

/**
 * This component is used to display the status of an entity.
 * It displays the current status and allows the user to change it.
 * This is a generic component that can be used to display the status of any entity.
 *
 * @template T - The type of status values (should extend string)
 */
export const BaseStatusMenu = <T extends string>({
  canEdit,
  currentStatus,
  handleUpdateStatus,
  labelComponent,
  statuses,
  disabledStatuses = []
}: BaseStatusMenuProps<T>) => {
  const handleValueChange = (value: T) => {
    handleUpdateStatus({ status: value })
  }

  return (
    <GenericSelect
      options={statuses.map((status) => ({
        disabled: disabledStatuses.includes(status),
        label: labelComponent(status),
        value: status
      }))}
      onValueChange={(value: string) => handleValueChange(value as T)}
      value={String(currentStatus)}
      placeholder={currentStatus ? String(labelComponent(currentStatus)) : 'Select'}
      triggerClassName="w-full"
      disabled={!canEdit}
    />
  )
}
